// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__AustinMedium_e2b1a4', '__AustinMedium_Fallback_e2b1a4'"},"className":"__className_e2b1a4","variable":"__variable_e2b1a4"};